
    import './styles.scoped.css';
    export default {
  "badge": "awsui_badge_1yjyg_1tjxj_93",
  "badge-color-grey": "awsui_badge-color-grey_1yjyg_1tjxj_113",
  "badge-color-green": "awsui_badge-color-green_1yjyg_1tjxj_116",
  "badge-color-blue": "awsui_badge-color-blue_1yjyg_1tjxj_119",
  "badge-color-red": "awsui_badge-color-red_1yjyg_1tjxj_122"
};
  